import { BffPagination } from 'data/terra/api/terra/base/BffPagination';

export function hasMoreData(pagination: BffPagination): boolean {
  return pagination.page * pagination.pageSize < pagination.totalItems;
}
